import handler from 'api/handler'

const prefix = '/public/volunteer'

const methods = {
  register: args => handler({ method: 'post', url: `${prefix}/register`, args }),
  fetchAll: args => handler({ method: 'get', url: `${prefix}/fetch`, args })
}

export default methods
